import { Component } from '@angular/core';
import { ContractModelService } from '../contracts.model.service';

@Component({
  moduleId: module.id,
  templateUrl: 'contracts.postponement.component.html',
  providers: []
})

export class ContractsPostponementComponent {

  model: any = {};
  errorMessage: string;

  constructor(private contractModelService: ContractModelService) {
  }

  ngOnInit() {
    this.model = this.contractModelService.getData();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/dashboard/contracts/postponement/contracts.postponement.component.ts